/* tslint:disable:rule1 max-line-length */

import classnames from 'classnames';
import * as React from 'react';

export const TrashCan = ({ onClick, disabled }: { onClick?: (e: any) => void; disabled?: boolean }) => {
  const props = {
    width: '26px',
    height: '26px',
    role: disabled ? undefined : 'button',
    className: classnames('user-trash-can-icon', 'ms-1', {
      'user-trash-can-icon-disabled': disabled,
    }),
    onClick: disabled ? null : onClick,
    version: '1.1',
    viewBox: '0 0 97.83193334937096 101.38655480742452',
    fill: '#3023AE',
  };

  return (
    <svg {...props}>
      <g id='svg_3'>
        <path
          d='M37.7,85.6c0,0,0.1,0,0.1,0c1.4-0.1,2.4-1.2,2.3-2.6l-2.5-43.7c-0.1-1.4-1.2-2.4-2.6-2.3c-1.4,0.1-2.4,1.2-2.3,2.6     l2.5,43.7C35.3,84.5,36.4,85.6,37.7,85.6z'
          id='svg_4'
        />
        <path
          d='M50,85.6c1.4,0,2.5-1.1,2.5-2.5V39.4c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v43.7C47.5,84.5,48.6,85.6,50,85.6z'
          id='svg_5'
        />
        <path
          d='M62.1,85.6c0,0,0.1,0,0.1,0c1.3,0,2.4-1,2.5-2.3l2.5-43.7c0.1-1.4-1-2.5-2.3-2.6c-1.4-0.1-2.5,1-2.6,2.3l-2.5,43.7     C59.7,84.3,60.8,85.5,62.1,85.6z'
          id='svg_6'
        />
        <path
          d='M83.2,13.9H63.1l-1.4-6.4c-0.6-2.8-3.2-4.9-6.1-4.9L44.4,2.5h0c-2.9,0-5.4,2-6.1,4.8l-1.5,6.6h-20c-3.3,0-6,2.7-6,6V24     c0,3.3,2.7,6,6,6h0.9L22,88.7c0.4,4.9,4.5,8.8,9.4,8.8h37.1c4.9,0,9.1-3.9,9.4-8.8l4.3-58.8h0.9c3.3,0,6-2.7,6-6v-4.1     C89.2,16.6,86.5,13.9,83.2,13.9z M43.1,8.4c0.1-0.6,0.7-1,1.3-1c0,0,0,0,0,0l11.3,0.1c0.6,0,1.1,0.4,1.3,1l1.2,5.4H41.9L43.1,8.4     z M73.1,88.4c-0.2,2.4-2.2,4.2-4.5,4.2H31.5c-2.4,0-4.3-1.8-4.5-4.2l-4.3-58.4h54.6L73.1,88.4z M84.2,24c0,0.6-0.5,1-1,1H16.8     c-0.6,0-1-0.5-1-1v-4.1c0-0.6,0.5-1,1-1h66.4c0.6,0,1,0.5,1,1V24z'
          id='svg_7'
        />
      </g>
    </svg>
  );
};
